<template>
	<div
		:class="{'color-editing-panel border p-2': editing}"
		class="flex flex-auto flex-col overflow-hidden h-full"
	>
		<div
			v-if="editing"
			class="pb-2 flex edit-wap"
		>
			<div class="flex-1 min-w-0 overflow-hidden whitespace-no-wrap text-overflow-ellipsis">
				<slot name="name" />
			</div>
			
			<div
			v-if="hasSettings"
			class="button buttonwap button-panel-fuction"
			@click="settingsOpen = !settingsOpen">
				
				<div>
					<FontAwesomeIcon
						icon="cog"
						fixed-width
					/>
				</div>
			</div>
			
			
			
			
			<div
			v-if="depth > 0"
			class="button buttonwap button-panel-fuction"
			@click="remove">
				
				<div>
					<FontAwesomeIcon
						icon="trash-alt"
						fixed-width
					/>
				</div>
			</div>
			
			
			
		</div>
		<div
			v-if="!editing || isGrid"
			class="flex-grow overflow-hidden"
			:class="contentClass"
		>
			<slot />
		</div>
		<overlay
			v-if="settingsOpen"
			@close="settingsOpen = false"
		>
			<template #title>
				设置
			</template>
			<slot name="settings" />
		</overlay>
	</div>
</template>

<script>
import {mapState} from 'vuex'

import Overlay from '@/components/overlay'

export default {
	components: {
		Overlay
	},
	props: {
		contentClass: {
			type: null,
			default: ''
		},
		isGrid: {
			type: Boolean,
			default: () => false
		}
	},
	data() {
		return {
			settingsOpen: false
		}
	},
	computed: {
		...mapState(['editing']),
		depth() {
			return this.$parent.depth
		},
		id() {
			return this.$parent.id
		},
		panel() {
			return this.$parent.panel
		},
		hasSettings() {
			return Boolean(this.$slots.settings)
		}
	},
	watch: {
		editing(newval) {
			if (!newval) {
				this.settingsOpen = false
			}
		}
	},
	methods: {
		remove() {
			this.$store.dispatch('layout/removePanel', {id: this.id})
		}
	}
}
</script>
